export default "__VITE_ASSET__MfWEBgJ8__"